/**
 * Density and chrome overrides shared by the two Dispatch tables.
 *
 * These live in the ~500px inbox side panel, where `DataTable`'s stock
 * `p-4` cells spend roughly 160px of the available width on padding alone
 * and push columns off the edge. Halving the horizontal padding is what
 * buys the room back; the rest is trim.
 *
 * Applied via `containerClassName`/`toolbarClassName` so the override is
 * scoped to these two tables -- `Table.tsx` is shared with every other
 * table in the app and must not be narrowed for their sake.
 */
export const DISPATCH_TABLE_CLASSNAMES = {
  /**
   * The white card is drawn here, around the table alone, rather than by the
   * parent around table + toolbar together. That leaves the Columns button
   * sitting on the panel's own slate background and puts the rounded corners
   * on the top of the table itself.
   *
   * `overflow-hidden` is load-bearing: the sticky `<thead>` paints its own
   * background, so without it the header squares off the two rounded top
   * corners. It does not interfere with the horizontal scroll, which lives on
   * an inner `overflow-auto` wrapper in `Table.tsx`.
   */
  container:
    "overflow-hidden rounded-[10px] border-slate-200 bg-white shadow-[0_1px_2px_#0000000A] [&_th]:h-9 [&_th]:px-2 [&_td]:px-2 [&_tbody_td]:py-1",
  /**
   * The stock toolbar row is `py-4` with an `h-10 w-24` button -- a lot of
   * empty space above a table someone opened to read. The descendant
   * selector shrinks the Columns button without adding another prop to the
   * shared `DataTable`; these two tables put nothing else in this row.
   */
  toolbar:
    "justify-end py-2 [&_button]:h-7 [&_button]:w-auto [&_button]:px-2.5 [&_button]:text-xs",
} as const;
